import React from 'react';
import * as core from 'cw-ui-core';
import css from './ApproveMatchedContactsDialog.scss';
import Locale from 'src/i18n';

export const APPROVE_MATCHED_CONTACTS_DIALOG = 'APPROVE_MATCHED_CONTACTS_DIALOG';

const ApproveMatchedContactsDialog = props => {
    const dialogButtons = [
        <core.ButtonLight
            key="back"
            automationName="back"
            className={css.backButton}
            value={core.formatMessage(Locale.back)}
            onClick={props.onBackButtonClick}
        />,
        <core.ButtonStandard
            key="close"
            automationName="close"
            className={css.approveButton}
            value={core.formatMessage(Locale.close)}
            onClick={props.onCloseButtonClick}
        />,
    ];

    return (
        <core.Dialog
            dialogId={APPROVE_MATCHED_CONTACTS_DIALOG}
            buttons={dialogButtons}
            className={css.approveMatchedContactsDialog}>
            <core.Label value={core.formatMessage(Locale.cancelMatchedContactsText)} grey7 />
        </core.Dialog>
    );
};

export default ApproveMatchedContactsDialog;
